export enum CALENDAR_VIEWS {
  CALENDAR,
  LIST,
}
